var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 396,
    viewBox: "0 0 340 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.058 128.276C266.792 169.444 251.783 212.439 219.815 237.353L241.874 311.397C243.858 318.058 240.07 325.061 233.409 327.045L187.426 340.744C180.766 342.728 173.763 338.94 171.778 332.28L149.72 258.236C109.661 254.904 73.837 227.575 61.6656 186.719C45.6712 133.031 76.657 76.522 130.749 61.2525C182.976 46.5177 238.02 76.4375 254.058 128.276Z",
    fill: "#B8AC97",
    stroke: "#B8AC97",
    strokeWidth: 53,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.375 129.308C266.547 170.164 251.52 212.643 219.815 237.353L231.958 278.113L161.862 298.995L149.719 258.236C109.661 254.904 73.8368 227.575 61.6654 186.719C45.8138 133.51 76.1089 77.52 129.318 61.6684C182.527 45.8167 238.524 76.0994 254.375 129.308Z",
    stroke: "#180A0A",
    strokeWidth: 19.8604,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.959 278.113L241.875 311.397C243.859 318.058 240.071 325.061 233.41 327.045L187.427 340.744C180.767 342.728 173.763 338.94 171.779 332.279L161.863 298.995",
    stroke: "#180A0A",
    strokeWidth: 19.8604,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.554 291.937L149.202 169.917C148.928 168.997 149.781 168.148 150.694 168.408L161.413 171.465C161.88 171.597 162.385 171.436 162.688 171.054L170.672 161.006C171.279 160.241 172.496 160.473 172.775 161.412L209.532 284.794",
    stroke: "#180A0A",
    strokeWidth: 17.1433,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254.08,
    height: 337.05,
    fill: "white",
    transform: "translate(0 72.543) rotate(-16.5895)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.b062727e81c1081ec7d18a372531f540.svg";
export { ForwardRef as ReactComponent };